<template>
    <div>
        <div class="actions__container">
            <div>
                <router-link class="btn btn-primary w-40 inline-block mr-1 mb-2" :to="{ name: 'discount-create' }">
                    Создать
                </router-link>
            </div>
        </div>

        <ContentSearch />

        <ContentTable
            :table-actions="tableActions"
            :headers="tableHeaders"
            :table-rows="tableData"
            :meta="pagination"
            :loading="loading"
            @edit="editAction"
            @delete="deleteAction"
        />

        <PopupDeleteModal
            :is-open="modalDeleteOpen"
            :entity-name="modalDeleteCaption"
            :modal-data="modalDeleteRow"
            @update:isOpen="modalDeleteOpen = $event"
            @deleteModalAccepted="onDeleteModalAccepted"
        />
    </div>
</template>

<script>
import ContentTable from '@/components/tables/ContentTable';
import PopupDeleteModal from '@/components/modals/PopupDeleteModal';
import { errorResponse } from '@/mixins/form/form-mixin';
import ContentSearch from '../../components/base/ContentSearch';
import { mapGetters } from 'vuex';
import { pageMixin } from '@/mixins/pageMixin';

export default {
    components: { ContentSearch, PopupDeleteModal, ContentTable },
    mixins: [errorResponse, pageMixin],
    async beforeRouteUpdate(to, from, next) {
        await this.fetchData({ ...to.query });
        next();
    },
    data() {
        return {
            tableActions: [
                { name: 'edit', title: 'редактировать', icon: 'Edit2Icon', cbName: 'edit' },
                { name: 'delete', title: 'удалить', class: 'bg-red-400', icon: 'Trash2Icon', cbName: 'delete' },
            ],
            addButtonDelete: false,
            tableHeaders: [
                { field: 'id', label: '#' },
                { field: 'name', label: 'Название' },
            ],
            loading: false,
            tableData: [],
            pagination: null,
            modalDeleteOpen: false,
            modalDeleteCaption: null,
            modalDeleteRow: null,
        };
    },
    computed: {
        ...mapGetters({ getUser: 'user/getUser' }),
    },
    async created() {
        this.$store.commit('main/setPageHeader', 'Акции');
        await this.fetchData(this.$route.query);
    },
    methods: {
        async fetchData(params) {
            try {
                this.loading = true;
                const { data } = await this.axios.get('/discounts', { params });
                this.tableData = data.data;
                this.pagination = data.meta;
            } catch (ex) {
                console.log('cant fetch data: ' + ex);
            } finally {
                this.loading = false;
            }
        },
        editAction(row) {
            // this.$router.push({ name: 'discount-edit', params: { id: row.id } });
            this._pMTransitionToEditPageWithQuery('discount-edit', { id: row.id });
        },
        deleteAction(row) {
            this.modalDeleteOpen = true;
            this.modalDeleteCaption = 'скидку';
            this.modalDeleteRow = row;
        },
        onDeleteModalAccepted(data) {
            this.axios
                .delete('/discounts/' + data.id)
                .then(() => {
                    this.fetchData(this.$route.query);
                    this.modalDeleteOpen = false;

                    this.$notify('Акция удалена');
                })
                .catch((ex) => {
                    this.errorResponse(ex);
                });
        },
    },
};
</script>

<style></style>
